import MainLayout from 'Components/Layout/MainLayout';
import {Button, message, Space, Spin} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import React, {useRef} from 'react';
import Style from './index.module.scss';
import TableRender, {ProColumnsType, TableContext} from 'table-render';
import useTable from '../../../../Utils/Hooks/useTable';
import {
    changeServiceStatus,
    getServicePage,
    ServiceData,
    ServiceType,
} from '../service';
import {useDict} from '../dict';
import useModalHandler from '../../../../Utils/Hooks/useModalHandler';
import EditModal from './Components/EditModal';
import SelectDict from '../../../../Features/Select/SelectDict';
import ProTable from '../../../../Components/ProTable';
import {Status} from '../../../../Services/common';
import useRequestFn from '../../../../Utils/Hooks/useRequestFn';
import {errorMessage} from '../../../../Utils/common';
import OverText from '../../../../Components/OverText';
import MenuModal from './Components/MenuModal';

export default function UserManage() {
    const {tableInit} = useTable(getServicePage, {});
    const tableRef = useRef<TableContext>(null);
    const dict = useDict();

    const editModal = useModalHandler({component: EditModal});
    const menuModal = useModalHandler({component: MenuModal});

    function reload(stay = true) {
        tableRef?.current?.refresh({
            stay,
        });
    }

    function onEditOk() {
        editModal.close();
        menuModal.close();
        reload();
    }

    const toolBar = (
        <div className={Style.toolBar}>
            <Space>
                <Button
                    type="primary"
                    onClick={() =>
                        editModal.open({
                            parentId: '0',
                            type: ServiceType.Service,
                            onOk: onEditOk,
                        })
                    }
                    icon={<PlusOutlined />}>
                    新增
                </Button>
            </Space>
        </div>
    );

    const schema = {
        type: 'object',
        labelWidth: 80,
        properties: {
            name: {
                title: '名称',
                type: 'string',
            },
            status: {
                title: '状态',
                type: 'string',
                widget: 'SelectDict',
                props: {
                    options: dict.Status.data,
                },
            },
        },
    };

    const [changeStatusAction, {loading: changeLoading}] =
        useRequestFn(changeServiceStatus);

    async function changeStatus(id: string, status: Status) {
        try {
            await changeStatusAction(id, status);
            await reload();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const columns: ProColumnsType<ServiceData> = [
        {title: '名称', dataIndex: 'name', width: 100},
        {title: '编码', dataIndex: 'code', width: 180},
        {
            title: '介绍',
            dataIndex: 'description',
            width: 140,
            render: text => <OverText text={text} />,
        },
        {
            title: '状态',
            dataIndex: 'status',
            render: dict.Status.getName,
            width: 60,
        },
        {title: '服务创建时间', dataIndex: 'createTime', width: 150},
        {
            title: '操作',
            dataIndex: 'id',
            align: 'center',
            width: 150,
            render: (id: string, item) => (
                <ProTable.Operate>
                    <Button
                        size="small"
                        type="link"
                        onClick={() =>
                            editModal.open({
                                parentId: '0',
                                type: ServiceType.Service,
                                id,
                                onOk: onEditOk,
                            })
                        }>
                        编辑
                    </Button>
                    <Button
                        size="small"
                        type="link"
                        onClick={() =>
                            menuModal.open({
                                current: id,
                                onOk: onEditOk,
                            })
                        }>
                        菜单管理
                    </Button>
                    <Button
                        size="small"
                        type="link"
                        onClick={() =>
                            changeStatus(
                                id,
                                item.status === Status.Freeze
                                    ? Status.Normal
                                    : Status.Freeze,
                            )
                        }>
                        {item.status === Status.Freeze ? '启用' : '停用'}
                    </Button>
                </ProTable.Operate>
            ),
        },
    ];

    return (
        <MainLayout.SpaceWrapper padding>
            <Spin spinning={changeLoading}>
                <TableRender
                    pageChangeWithRequest={false}
                    rowKey="id"
                    ref={tableRef}
                    search={{schema, widgets: {SelectDict}}}
                    columns={columns}
                    toolbarRender={toolBar}
                    expandable={{
                        showExpandColumn: false,
                    }}
                    {...tableInit()}
                />
            </Spin>

            {editModal.render()}
            {menuModal.render()}
        </MainLayout.SpaceWrapper>
    );
}
